import { useMutation } from '@tanstack/react-query';
import { authApi, type LoginBody, type SignupBody } from './authApi';
import { useAuth } from '@/providers/AuthProvider';

export function useLoginMutation() {
  const { login } = useAuth();
  return useMutation({
    mutationFn: (body: LoginBody) => authApi.login(body),
    onSuccess: (data) => {
      login(data.accessToken, data.user);
    },
  });
}

export function useSignupMutation() {
  const { login } = useAuth();
  return useMutation({
    mutationFn: (body: SignupBody) => authApi.signup(body),
    onSuccess: (data) => {
      login(data.accessToken, data.user);
    },
  });
}

export function useForgotMutation() {
  return useMutation({ mutationFn: (email: string) => authApi.forgot(email) });
}

export function useResetMutation() {
  return useMutation({
    mutationFn: ({ token, password }: { token: string; password: string }) =>
      authApi.reset(token, password),
  });
}

export function useVerifyEmailMutation() {
  const { refreshUser } = useAuth();
  return useMutation({
    mutationFn: (code: string) => authApi.verifyEmail(code),
    onSuccess: () => {
      void refreshUser();
    },
  });
}

export function useVerifyWhatsappMutation() {
  const { refreshUser } = useAuth();
  return useMutation({
    mutationFn: (code: string) => authApi.verifyWhatsapp(code),
    onSuccess: () => {
      void refreshUser();
    },
  });
}

export function useResendOtpMutation() {
  return useMutation({
    mutationFn: (channel: 'email' | 'whatsapp') => authApi.resendOtp({ channel }),
  });
}
